export default __webpack_public_path__ + "static/media/330_portfolio04-es-web.2d840fd9.png";